export const missingPackErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('UnavailablePackSafeResourceError') !== -1) {
			return {
				type: 'missingPackErrorTest',
				color: 'IndianRed',
				title: 'Missing Expansion Resource Error',
				text: 'Modification requires resources from an expansion.',
				description: 'A modification requires a resource from an Expansion Pack, Game Pack, or Stuff Pack to work properly.<br/>' +
        'You\'re not able to use a mod that requires an expansion without owning that expansion.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>2b9b735ad94a02575c9d7adb</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-03-29 02:55:17</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.67.1020-1.200.000.385.Release</buildsignature>
        <categoryid>instance_manager.py:566</categoryid>
        <desyncid>2b9b735ad94a02575c9d7adb</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[cjiang] Error occurred within the tag named 'sim_filter' (value: V) (UnavailablePackSafeResourceError)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 144, in _execute_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 433, in load_data_into_class_instances
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 658, in load_from_xml
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 703, in feed
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 747, in _load_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 807, in _load_tunable
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\serialization.py&quot;, line 796, in _load_tunable
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 1188, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 2119, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 2099, in load_etree_node
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 566, in get
sims4.tuning.merged_tuning_manager.UnavailablePackSafeResourceError
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/missingPackErrorTest.js